<template>
    <v-container max-width="100%" style="margin-top: 2%">

    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-autocomplete v-model="idTipoCercaSelected" :items="tiposCercas" item-text="descricao_tipo_cerca"
              item-value="id_tipo_cerca" clearable :label="$t('geofenceVehicles.typeGeofence')"
              @change="tipoCercaChanged"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
              item-value="id_empresa" clearable :label="$tc('vehicle.self', 1)"
              @change="empresaChanged"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-autocomplete v-model="idLinhaSelected" :items="linhasSelect" item-text="nome_linha" item-value="id_linha"
              clearable multiple :label="$tc('line.self', 1)" @change="linhaChanged"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <v-autocomplete v-model="idCercasSelected" :items="cercasSelect" item-text="nome_cerca"
              item-value="id_cerca" clearable multiple :label="$tc('geofence.self', 1)"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaRelatorio">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <div ref="pdfdiv">
      <v-data-table :headers="headers" :items="veiculosFiltered" sort-by="numero_ordem" dense class="elevation-7"
        locale="pt" :loading="loading" :loading-text="$t('system.messages.loading')" :search="search"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px">
        <template v-slot:top>
          <v-toolbar flat color="white" style="border-radius: 10px;">
            <v-toolbar-title style="color: #4a4a4a">{{ $t('relVehicleGeofence.vehicleXGeofence') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('system.search')" single-line
              hide-details></v-text-field>
            <v-spacer></v-spacer>

            <vue-json-to-csv :json-data="veiculosFiltered" :csv-title="'cercasxveiculos'" separator=";">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                    <v-icon>mdi-export-variant</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('system.labels.exportToCsv') }}</span>
              </v-tooltip>
            </vue-json-to-csv>

            <export-table-pdf :title="$t('relVehicleGeofence.vehiclesInGeofence')" :content="veiculosFiltered"
              :headers="headers" filename="cercasxveiculos"
              :subtitle="$t('relVehicleGeofence.vehicleXGeofence')"></export-table-pdf>
          </v-toolbar>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import DateUtils from "../utils/dateutils";
import VueJsonToCsv from "vue-json-to-csv";
import ExportTablePdf from "./ExportTablePdf.vue";
import translateDbField from "@/utils/translateDbField";

export default {
  components: {
    VueJsonToCsv,
    ExportTablePdf
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    formValidado: false,
    loading: false,
    timeProps: {
      useSeconds: true,
    },
    dti: null,
    dtf: null,
    idEmpresaSelected: null,
    idTipoCercaSelected: null,
    idCercasSelected: [],
    idLinhaSelected: [],
    isLinhaSelectDisabled: false,
    empresas: [],
    veiculos: [],
    linhas: [],
    linhasSelect: [],
    cercas: [],
    cercasUnicas: [],
    cercasSelect: [],
    tiposCercas: [],
    config: null,
  }),
  computed: {

    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    today() {
      let td = new Date();
      return td.toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.today
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min
      }
    },
    veiculosFiltered() {
      return this.veiculos;
    }
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() { },
  methods: {

    initialize() {
      this.getConfig();
      this.populaEmpresas();
      this.populaLinhas();
      this.populaTiposCercas();
      this.populaCercas();
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
        }
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        }
      });
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        onSuccess: (response) => {
          this.linhas = response.data;
        }
      });
    },
    populaCercas() {
      apiController.request(apiController.endpoints.getallCercasativascomtipo, {
        onSuccess: (response) => {
          this.cercas = response.data;
          this.cercasUnicas = [];
          this.cercas.forEach((c) => {
            if (this.cercasUnicas.findIndex((e) => e.id_cerca === c.id_cerca) === -1) {
              this.cercasUnicas.push(c)
            }
          });
          this.populaCercasSelect();
        }
      });
    },
    populaTiposCercas() {
      apiController.request(apiController.endpoints.getTiposcerca, {
        onSuccess: (response) => {
          this.tiposCercas = response.data.map(tipoCerca => {
            const translated = translateDbField(
              tipoCerca.translation_key,
              tipoCerca.descricao_tipo_cerca
            );
            return {
              ...tipoCerca,
              descricao_tipo_cerca: translated
            };
          });
        }
      });
    },
    populaLinhasSelect() {
      if (this.idEmpresaSelected) {
        this.linhasSelect = this.linhas.filter((l) => l.id_empresa == this.idEmpresaSelected);
      } else {
        this.linhasSelect = this.linhas;
      }
    },
    populaCercasSelect() {
      if (this.idTipoCercaSelected) {
        this.cercasSelect = this.cercasUnicas.filter((c) => c.id_tipo_cerca == this.idTipoCercaSelected);
      } else {
        this.cercasSelect = this.cercasUnicas;
      }
    },
    populaVeiculos() {
      this.loading = true;
      let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
      let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

      let temp = {
        idcercas: this.idCercasSelected.length > 0 ? this.idCercasSelected : this.cercasSelect.map((c) => c.id_cerca),
        dti: dataInicial,
        dtf: dataFinal
      }

      apiController.request(apiController.endpoints.getVeiculoscercas, {
        data: temp,
        onSuccess: (response) => {
          this.veiculos = response.data;
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        }
      });

    },
    populaRelatorio() {
      this.$refs.form.validate();
      if (this.formValidado) {
        this.veiculos = [];
        this.populaVeiculos();
        this.$nextTick(() => { this.$refs.form.resetValidation(); });
      }
    },
    linhaChanged() {
    },
    empresaChanged() {
      this.populaLinhasSelect();
    },
    tipoCercaChanged() {
      if (this.idTipoCercaSelected) {
        let idCercasTipo = this.cercas.filter((c) => c.id_tipo_cerca === this.idTipoCercaSelected).map((c) => c.id_cerca);
        this.cercasSelect = this.cercasUnicas.filter((c) => idCercasTipo.includes(c.id_cerca));
      } else {
        this.cercasSelect = this.cercasUnicas;
      }
    }
  },
};
</script>